

import React, { Component } from 'react';

export default class ProductionTransactionItem extends React.Component {
  constructor(props) {
    super();
    this.state = {
      insufficientStock: false,
      invalidQuantityValue: false,
      isValidItemState: false,
    };
  }

  handleQuantityChange = (fields_for, item, quantity) => {

    let isValidItem = true
    if (fields_for == 'output_items' ) return;
    const availableStock = this.props.getStockCountHandler(item.id, fields_for)

    //Make sure value exists
    if(isNaN( parseFloat(quantity)))
    {
      isValidItem = false
    }
    // Make sure sufficient stock exists
    if (parseFloat(quantity) > parseFloat(availableStock)) {
      this.setState({ insufficientStock: true})
      isValidItem = false
    }
    else{
      this.setState({ insufficientStock: false })
      
    }

    //Make sure the quantity entered matches the input quantity/multiple
    
    if (quantity % parseFloat( item.quantity) != 0)
    {
      this.setState({ invalidQuantityValue: true })
      isValidItem = false
    }
    else{
      this.setState({ invalidQuantityValue: false })
    }

    // alert("isValidItem: " + isValidItem)
    item.isValid = isValidItem
   
    // this.setState({ isValidItemState: isValidItem }, alert('isValidItem callback: ' + this.isValidItem()))
    this.props.updateQuantityHandler(fields_for, item, quantity)
    
  }

  isValidItem = () => {
    return this.state.isValidItemState
  }
  

  
  render() {
    const item = this.props.item 

    return (
      <div>
        <div className='form-group form-group-default'>

          <label>
            {item.name} (Min. Qty: <strong>{prettyFloat(item.quantity)}</strong> ) (Available Stock: <strong> {this.props.getStockCountHandler(item.id, this.props.fields_for)} </strong>)
  </label>
          <input
            type="text"
            className="form-control alert alert-warning"
            value = {item.processingQuantity}
            onChange={(e) => { this.handleQuantityChange(this.props.fields_for, item, e.target.value) }}
          />
      
        </div>
      <div className={this.state.insufficientStock ? '' : 'hide'}>

          <label className="alert alert-danger " >Insufficient Stock. Only {this.props.getStockCountHandler(item.id, this.props.fields_for)} available!</label>
      </div>
      <div className={this.state.invalidQuantityValue ? '' : 'hide'}>

          <label className="alert alert-danger " >Invalide Quantity Value. Use {prettyFloat(item.quantity)} or its multiples!</label>
      </div>

      </div>
    );
  }
}